export function base(projectUID) {
  return projectUID ? `/surveys/${projectUID}` : '/surveys'
}

export function checkout(projectUID) {
  return `/surveys/${projectUID}/checkout`
}

export function validate(projectUID) {
  return `/surveys/${projectUID}/validate_structure`
}

export function requestAccessToken(projectUID) {
  return `/surveys/${projectUID}/request_access`
}

export function transferControl(projectUID) {
  return `/surveys/${projectUID}/transfer_control`
}

export const editAction = 'edit'

export const viewAction = 'view'

export const correctAction = 'correct'

export const versionAction = 'version'

export const checkoutAction = 'launch_checkout'

export const newTargetMarketAction = 'new'

export const translateAction = 'translate'

export const editTargetMarketAction = 'tm'

export const graphQLEndPoint = '/graphql'

import {
  getImageAssetPath,
  IMAGE_ASSET_PATH_FILTER_RESIZE_TO_FIT,
  IMAGE_ASSET_PATH_GRAVITY_CENTER
} from '@aytm/lib/common/assets'
export function imageAsset(
  path,
  {
    width = 250,
    height = 250,
    filter = IMAGE_ASSET_PATH_FILTER_RESIZE_TO_FIT,
    backgroundColor = 'white',
    unsharp = false,
    gravity = IMAGE_ASSET_PATH_GRAVITY_CENTER,
    animated = false,
    trim = false
  } = {}
) {
  return getImageAssetPath({
    path,
    filter,
    width,
    height,
    backgroundColor,
    unsharp,
    gravity,
    animated,
    trim
  })
}

export function getMultilingualRoute(researcherLanguage, languageUID = '', base = '/') {
  return !researcherLanguage && !languageUID
    ? `${base}${translateAction}`
    : languageUID === researcherLanguage
    ? `${base}${editAction}`
    : `${base}${translateAction}/${viewAction}/${languageUID}`
}
